module.exports = __webpack_public_path__ + "media/images/logo-a26448ce737a5208e3e00c98a8d3ef4a.png";